import React, { useContext } from 'react';
import { RestrictionsContext } from 'providers/context';

export default function useRestrictions(context = RestrictionsContext) {
  return useContext(context);
}
